import { type Board, type User } from '@apps/www/src/__generated__/graphql';
import cn from '@pkgs/shared-client/helpers/cn';
import SVA from './SVA';
import SVButton from './SVButton';
import SVLink from './SVLink';

type Props = {
	userName: User['username'];
	userURL: User['url'];
	acceptURL: NonNullable<Board['acceptURL']>;
	rejectURL: NonNullable<Board['rejectURL']>;
};

const SVBoardInviteBanner = ({ userName, userURL, acceptURL, rejectURL }: Props) => (
	<div
		className={cn(
			'flex-center bg-primary -sm:flex-col relative m-auto mb-12 mt-5 flex h-[90px] w-[450px] max-w-xl items-center space-x-4 rounded-xl p-4 shadow-lg ring-1 ring-black/5',
		)}
	>
		<div>
			<SVA className="text-sm font-semibold text-gray-700" Component={SVLink} to={userURL}>
				{userName}
			</SVA>{' '}
			<span className="text-sm font-medium text-gray-400">
				invited you to collaborate on this board.
			</span>
		</div>
		<div className="flex space-x-3">
			<SVButton
				className="type-small text-primary rounded-xl bg-gray-800 px-5 py-3.5 font-medium transition-colors hover:bg-gray-700"
				Component={SVLink}
				to={acceptURL}
			>
				Accept
			</SVButton>
			<SVButton
				className="type-small text-primary rounded-xl bg-gray-800 px-5 py-3.5 font-medium transition-colors hover:bg-gray-700"
				Component={SVLink}
				to={rejectURL}
			>
				Reject
			</SVButton>
		</div>
	</div>
);

export default SVBoardInviteBanner;
